// @mui
import { Box, Paper, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { fData } from 'src/utils/format-number';
// utils
// ----------------------------------------------------------------------

export function RejectionFiles({ fileRejections }: any): JSX.Element {
  return (
    <Paper
      variant="outlined"
      sx={{
        py: 1,
        px: 2,
        mt: 3,
        borderColor: 'error.light',
        bgcolor: (theme) => alpha(theme.palette.error.main, 0.08),
      }}>
      {fileRejections?.map(({ file, errors }: any) => {
        const { path, size } = file;

        return (
          <Box key={path} sx={{ my: 1 }}>
            <Typography variant="subtitle2" noWrap>
              {fData(size)}
            </Typography>

            {errors.map((error: any) => (
              <Typography key={error.code} variant="caption" component="p">
                {error.code === 'file-too-large'
                  ? `File size is too large (MAX 10 MB)`
                  : error.message}
              </Typography>
            ))}
          </Box>
        );
      })}
    </Paper>
  );
}
